import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSuccessIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	stroke: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.3337 9.99935C18.3337 14.6018 14.6028 18.3327 10.0003 18.3327C5.39783 18.3327 1.66699 14.6018 1.66699 9.99935C1.66699 5.39685 5.39783 1.66602 10.0003 1.66602C14.6028 1.66602 18.3337 5.39685 18.3337 9.99935ZM13.3587 7.47435C13.4757 7.59154 13.5414 7.75039 13.5414 7.91602C13.5414 8.08164 13.4757 8.24049 13.3587 8.35768L9.19199 12.5243C9.0748 12.6414 8.91595 12.7071 8.75033 12.7071C8.5847 12.7071 8.42585 12.6414 8.30866 12.5243L6.64199 10.8577C6.58059 10.8005 6.53133 10.7315 6.49717 10.6548C6.46302 10.5781 6.44465 10.4954 6.44317 10.4115C6.44169 10.3275 6.45712 10.2442 6.48856 10.1664C6.51999 10.0885 6.56678 10.0178 6.62613 9.95848C6.68548 9.89914 6.75617 9.85235 6.83399 9.82091C6.91182 9.78948 6.99518 9.77404 7.07909 9.77552C7.16301 9.777 7.24577 9.79537 7.32244 9.82953C7.39911 9.86369 7.46811 9.91294 7.52533 9.97435L8.75033 11.1993L10.6128 9.33602L12.4753 7.47435C12.5925 7.35731 12.7514 7.29157 12.917 7.29157C13.0826 7.29157 13.2415 7.35731 13.3587 7.47435Z",
		fill: "currentColor"
	})
});
export default SvgSuccessIcon;
